import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class UnitOfMeasurementService {
    constructor(http) {
        this.http = http;
        this.singular = 'unit of measurement';
        this.plural = 'unit of measurements';
        this.editor = PLATFORM.moduleName('pages/system-fields/unit-of-measurements/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`unit-of-measurements/filter/${loadOptions}`);
        return await response.json();
    }

    async create(unitOfMeasurement) {
        await this.http.fetch('unit-of-measurements', { method: 'POST', body: json(unitOfMeasurement) });
    }

    async update(unitOfMeasurement) {
        await this.http.fetch(`unit-of-measurements/${unitOfMeasurement.id}`, { method: 'PUT', body: json(unitOfMeasurement) });
    }

    async delete(id) {
        await this.http.fetch(`unit-of-measurements/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`unit-of-measurements/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`unit-of-measurements/top-three/${query}`);
        return await response.json();
    }
}